import React, { useState, useMemo, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import classNames from "classnames";
import "./modal.scss";
import { Autocomplete, TextField, Checkbox } from "@mui/material";
import CustomSelect from "../input/select";
import Chip from "@mui/material/Chip";
import { hasDangerousCode } from "../../utils/utils";
import DropdownWithOther from "../Dropdown/DropdownWithOther";

const Input = ({
  name,
  error,
  validation,
  rowHasError,
  errorMessage,
  childHasError,
  columnDataArr,
  value,
  classes,
  tableName,
  ...props
}) => {
  const [hasError, setError] = useState(false);
  const handleOnChange = (e) => {
    const hasError = validation(e, columnDataArr);
    if (!hasError) {
      childHasError(true);
      setError(true);
    } else {
      childHasError(false);
      setError(false);
    }
    props.onChange(e);
  };

  return (
    <>
      <div
        className={classNames(
          classes.inputWrapperDiv,
          `inputWrapperDiv${tableName}`,
        )}
      >
        <textarea
          className={classNames(classes.input, `input${tableName}`)}
          rows={2}
          name={name}
          value={value || ""}
          disabled={props.readonly}
          onChange={handleOnChange}
          style={{ width: "100%" }}
        />
      </div>
    </>
  );
};

export const EditableRowPPB = ({
  keys,
  updateAlert,
  tableName,
  customStyles,
  wholeRowData,
  editingIndex,
  handleDeleteRow,
  allRowsData,
  editData = {},
  classes = {},
  updateSourceInputs,
  sourceData,
  selectClasses,
  inputClasses,
  rowData,
  setRowData,
  dropdownOptions,
  setDropdownOptions,
  setUpdatedRowData,
  rowHasError,
  setRowHasError,
  errorMessage,
  setErrorMessage,
  rbBrandValues,
  setRbBrandValues,
  ...props
}) => {
  const [currentKey, setCurrentKey] = useState({});
  const [currentValue, setCurrentValue] = useState([]);
  const [newConditionKey, setNewConditionKey] = useState({});
  const [newConditionValue, setNewConditionValue] = useState([]);
  const [currentCondition, setCurrentCondition] = useState([]);
  const [dropdownData, setDropDownData] = useState(
    sourceData?.data?.dropdown || {},
  );
  const [levelColKeys, setLevelColKeys] = useState([]);
  const SOURCE_NAME =
    sourceData?.data?.dropdown?.source_alias_for_dropdown?.find(
      (item) => item.label === sourceData?.current_source?.value,
    )?.name ||
    sourceData?.current_source?.value ||
    "";
  const Edit_Column_Module = dropdownData?.edit_model_column_list || [];

  const is_Level_Column_Editable = useMemo(() => {
    return (
      currentKey &&
      Object.keys(currentKey).length > 0 &&
      currentValue &&
      currentValue.length > 0
    );
  }, [currentKey, currentValue]);

  const is_New_Condition_Valid = useMemo(() => {
    return (
      newConditionValue &&
      Object.keys(newConditionValue).length > 0 &&
      newConditionValue &&
      newConditionValue.length > 0
    );
  }, [newConditionKey, newConditionValue]);

  // CHECKS POWER_BRAND COLUMN IN CURRENT RECORD HAS Other_reckitt_brand AS VALUE
  const is_Other_Reckit_Brands_Not_Applicable = useMemo(() => {
    if (wholeRowData?.isNewData) return false;
    const Is_Single_Insert = Object?.keys(editData)?.some((key) => {
      // CHECKS CURRENT COLUMN APPLICABLE FOR OTHER RECKITT BRAND VALIDATION
      const is_single_insert_applicable_column =
        dropdownData?.is_single_insert_applicable_columns?.includes(key);
      // IF NOT VALID RETURN FALSE
      if (!is_single_insert_applicable_column) return false;

      // IF VALID AND THE COLUMN VALUE MATCHES ANY VALUE IN is_single_insert_applicable_values RETURN TRUE
      const result =
        !dropdownData?.is_single_insert_applicable_values?.includes(
          editData?.[key],
        );
      return result;
    });

    return Is_Single_Insert;
  }, [editData]);

  const validation = () => {
    return true;
  };

  const handleDropdownOptions = (key, value, itemName) => {
    // const dropdownData = sourceData?.data?.dropdown;
    const table_header_column_list = dropdownData?.table_header_column_list;
    const editModelList = dropdownData?.edit_model_column_list;
    const InValidDropDownData =
      !Array.isArray(table_header_column_list) || !Array.isArray(editModelList);

    if (InValidDropDownData) {
      updateAlert({
        open: true,
        message: "Dropdown data is missing or not in expected format",
        severity: "error",
        closeFlag: true,
      });
      return;
    }

    // STEP 1 = CHECKS ALL VALUES IN ROWDATA ARE NULL
    let Is_All_Value_In_Row_Null = Edit_Column_Module.every((item) => {
      const options = dropdownData[item.name] || [];
      if (options.length === 0) return true;
      return key && value && itemName
        ? item.name === itemName
          ? value === null
          : rowData[item.name] === null
        : rowData[item.name] === null;
      // return rowData[item.name] === null;
    });

    // STEP 2 = CONDITION CHECK BASED ON STEP 1
    // IF SCOPE EXECUTES ONLY IF ISNEWROW === TRUE
    if (Is_All_Value_In_Row_Null) {
      // ASSIGNS THE DROPDOWN OPTIONS ONLY FOR FIRST COLUMN OF THE EDITABLE COLUMNS
      // FOR REST OF THE COLUMNS IT ASSIGNS EMPTY ARRAY
      Edit_Column_Module.map((item, i) => {
        const Current_Item_Table_Header = table_header_column_list.find(
          (th) => th.name === item.name,
        );
        if (i === 0) {
          if (
            Current_Item_Table_Header &&
            Current_Item_Table_Header.is_dependent
          ) {
            // GETS MATCHING OBJECT FROM DROPDOWN GROUP
            const DROPDOWN_VALUES = dropdownData?.[item.name].find(
              (dropdown_item) =>
                dropdown_item?.[Current_Item_Table_Header.parent_column] ===
                rowData?.[Current_Item_Table_Header.parent_column],
            );

            const FINAL_DROPDOWN_VALUES = [
              ...(dropdownData?.[DROPDOWN_VALUES?.[item.name]] || []),
              ...(Current_Item_Table_Header?.default_dropdown_values || []),
            ];

            setDropdownOptions((prev) => ({
              ...prev,
              [item.name]: FINAL_DROPDOWN_VALUES || [],
            }));
          } else {
            setDropdownOptions((prev) => ({
              ...prev,
              [item.name]: [
                ...(dropdownData?.[item.name] || []),
                ...(Current_Item_Table_Header?.default_dropdown_values || []),
              ],
            }));
          }
        } else {
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: [],
          }));
        }
      });
    } else {
      table_header_column_list.map((item) => {
        if (item.is_dependent) {
          const FilteredDropdownOptions = dropdownData[item.name]; //DROPDOWN OPTIONS OF PARTICULAR COLUMN
          const Parent_Column_Name = item.parent_column; // DEPENDENCY COLUMN NAME
          const Parent_Column_Value =
            key && value && itemName
              ? Parent_Column_Name === itemName
                ? value
                : rowData[Parent_Column_Name]
              : rowData[Parent_Column_Name]; //ROWDATA VALUE OF THE DEPENDENCY COLUMN NAME

          // FILTERS CORRECT DROPDOWN OPTIONS BASED ON THE DEPENDENCY COLUMN VALUE
          const filteredFinalOptions =
            Parent_Column_Value !== null
              ? FilteredDropdownOptions.filter(
                  (option) =>
                    option[Parent_Column_Name] === Parent_Column_Value,
                )
              : [];

          let FinalOptions;

          // CHECKS IF FILTERED DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          Edit_Column_Module.map((editItem) => {
            // IF NO THEN IT RETURN ENTIRE ARRAY
            if (editItem.name === item.name && editItem.isArray) {
              FinalOptions =
                filteredFinalOptions.length > 0
                  ? dropdownData[filteredFinalOptions[0][item.name]] || []
                  : [];
            }

            // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
            if (editItem.name === item.name && !editItem.isArray) {
              if (sourceData.current_source === "Pos") {
                FinalOptions =
                  filteredFinalOptions.length > 0
                    ? filteredFinalOptions[0][item.name][
                        rowData[editItem.parent_for_dropdown]
                      ]
                    : [];
              } else {
                const Header_Table_Values =
                  sourceData.current_filter_value === "Create new"
                    ? dropdownData[item.name][
                        editData[editItem.parent_for_dropdown].toUpperCase()
                      ]["HEADER_TABLE"][sourceData.current_country]
                    : dropdownData[item.name][
                        editData[editItem.parent_for_dropdown].toUpperCase()
                      ]["HEADER_TABLE"][sourceData.current_country][
                        sourceData.current_ssfFileId
                      ];
                FinalOptions = [
                  ...Header_Table_Values,
                  ...dropdownData[item.name][
                    editData[editItem.parent_for_dropdown].toUpperCase()
                  ]["BRONZE_TABLE"],
                ];
              }
            }
          });

          // SETS STATE WITH DROPDOWN OPTIONS FOR THE RESPECTIVE COLUMNS
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: [
              ...FinalOptions,
              ...(item?.default_dropdown_values || []),
            ],
          }));
        } else {
          // CHECKS IF COLUMN IN THE CURRENT ITERATION HAS DROPDOWN FIELD
          let result = Edit_Column_Module.find(
            (data) =>
              (data.type === "select" || data.type === "multi_select") &&
              item.name === data.name,
          );

          // IF YES THEN CHECKS IF THE COLUMNS DROPDOWN HAS DEPENDENCY BASED STRUCTURE
          // IF YES = IT FILTERS CORRECT OPTIONS BASED ON THE DEPENDENCY
          // IF NO THEN IT RETURN ENTIRE ARRAY
          let Final_DropDown_Values;
          if (result && result.type === "select") {
            Edit_Column_Module.forEach((editItem) => {
              if (editItem.name === item.name && editItem.isArray) {
                Final_DropDown_Values = dropdownData[item.name];
              }
            });
          }

          if (result && result.type === "multi_select") {
            Edit_Column_Module.forEach((editItem) => {
              if (editItem.name === item.name && editItem.isArray) {
                Final_DropDown_Values = dropdownData[item.name];
              }
            });
          }

          // SETS STATE WITH DROPDOWN OPTIONS FOR THE RESPECTIVE COLUMNS
          setDropdownOptions((prev) => ({
            ...prev,
            [item.name]: [
              ...(Final_DropDown_Values || []),
              ...(item?.default_dropdown_values || []),
            ],
          }));
        }
      });
    }
  };

  const removeEmptyColumnForLevelsColumn = (
    currentList,
    otherLocalAttributeKeys,
  ) => {
    const SortedListByRemovingColumnsThatHasEmptyValue = Object.fromEntries(
      Object.entries(currentList).filter(([key, value]) => value.length > 0),
    );
    const FinalKeys =
      Object.keys(SortedListByRemovingColumnsThatHasEmptyValue)?.map(
        (item) => ({ label: item, value: item }),
      ) || [];
    if (otherLocalAttributeKeys && otherLocalAttributeKeys.length > 0) {
      // setLevelColKeys([
      //   ...FinalKeys,
      //   {
      //     label: "OTHER_LOCAL_ATTRIBUTE_KEY",
      //     value: "OTHER_LOCAL_ATTRIBUTE_KEY",
      //   },
      //   {
      //     label: "OTHER_LOCAL_ATTRIBUTE_VALUE",
      //     value: "OTHER_LOCAL_ATTRIBUTE_VALUE",
      //   },
      // ]);
      setLevelColKeys([...FinalKeys]);
    } else {
      setLevelColKeys([...FinalKeys]);
    }
  };

  useEffect(() => {
    handleDropdownOptions();
  }, [sourceData.data]);

  useEffect(() => {
    const SORTED_DROPDOWN_NAME = `${
      SOURCE_NAME || sourceData?.current_source?.value
    }_BRAND`;

    let Final_Dropdowns = {};
    let FINAL_FILTERED_RB_BRAND = [];
    let FINAL_POWER_BRAND = [];

    sourceData?.data?.dropdown?.dropdown?.forEach((item) => {
      // NORMAL DROPDOWN DATA
      const { HARBOR_SOURCE_FILE_ID, ...rest } =
        sourceData?.data?.dropdown?.dropdown?.find((match) => {
          return (
            match.HARBOR_SOURCE_FILE_ID ===
            wholeRowData.rowData.HARBOR_SOURCE_FILE_ID
          );
        }) ?? {};

      // GOLD TABLE DROPDOWN DATA
      const { gold_mapping } =
        sourceData?.data?.dropdown?.gold_table_data?.find(
          (item) =>
            item.HARBOR_SOURCE_FILE_ID ===
            wholeRowData.rowData.HARBOR_SOURCE_FILE_ID,
        ) ?? {};

      // OTHER LOCAL ATTRIBUTE DROPDOWN DATA
      const { attributes_map } =
        sourceData?.data?.dropdown?.other_local_attribute_map?.find((match) => {
          return (
            match.HARBOR_SOURCE_FILE_ID ===
            wholeRowData.rowData.HARBOR_SOURCE_FILE_ID
          );
        }) ?? {};

      // GOLD OLT DROPDOWN DATA
      const MATCHING_OLT_GOLD_DROPDOWN =
        sourceData?.data?.dropdown?.gold_table_data_olt?.find((match) => {
          return (
            match.HARBOR_SOURCE_FILE_ID ===
            wholeRowData.rowData.HARBOR_SOURCE_FILE_ID
          );
        }) ?? {};
      const OLT_GOLD_MAPPING = MATCHING_OLT_GOLD_DROPDOWN?.gold_mapping || {};

      const MATCH =
        item.HARBOR_SOURCE_FILE_ID ===
        wholeRowData.rowData.HARBOR_SOURCE_FILE_ID;

      if (MATCH) {
        if (!gold_mapping || Object.keys(gold_mapping).length === 0) {
          Final_Dropdowns = {
            ...Final_Dropdowns,
          };
        } else {
          // DROPDOWN MAPPING AS PER GOLD TABLE DROPDOWN METADATA
          Object.keys(gold_mapping)?.forEach((gold_item) => {
            const IS_OLT = gold_mapping?.[gold_item]
              ?.toLowerCase()
              ?.includes("olt");
            if (IS_OLT) {
              const OLT_REMOVED_NAME =
                gold_mapping?.[gold_item]?.replace(/^olt_/i, "") ?? "";
              Final_Dropdowns = {
                ...Final_Dropdowns,
                [gold_item]: attributes_map?.[OLT_REMOVED_NAME ?? ""] || [],
              };
            } else {
              if (gold_mapping?.[gold_item] === SORTED_DROPDOWN_NAME) {
                FINAL_FILTERED_RB_BRAND =
                  rest?.[gold_mapping?.[gold_item] ?? ""] || [];
                FINAL_POWER_BRAND =
                  rest?.[gold_mapping?.[gold_item] ?? ""] || [];
              }
              Final_Dropdowns = {
                ...Final_Dropdowns,
                [gold_item]: rest?.[gold_mapping?.[gold_item] ?? ""] || [],
              };
            }
          }) ??
            // DROPDOWN MAPPING AS PER GOLD TABLE OLT DROPDOWN METADATA
            Object.keys(OLT_GOLD_MAPPING || {})?.forEach((olt_gold_item) => {
              const IS_OLT = OLT_GOLD_MAPPING?.[olt_gold_item]
                ?.toLowerCase()
                ?.includes("olt");

              if (IS_OLT) {
                const OLT_REMOVED_NAME = OLT_GOLD_MAPPING?.[
                  olt_gold_item
                ]?.replace(/^olt_/i, "");
                Final_Dropdowns = {
                  ...Final_Dropdowns,
                  [olt_gold_item]:
                    attributes_map?.[OLT_REMOVED_NAME ?? ""] || [],
                };
              } else {
                Final_Dropdowns = {
                  ...Final_Dropdowns,
                  [olt_gold_item]:
                    rest?.[OLT_GOLD_MAPPING?.[olt_gold_item] ?? ""] || [],
                };
              }
            });
        }
      }
    });

    // OTHER_LOCAL_ATTRIBUTES
    const OtherLocalAttributesList =
      sourceData?.data?.dropdown?.gold_table_data_olt?.find(
        (item) =>
          item.HARBOR_SOURCE_FILE_ID ===
          wholeRowData.rowData.HARBOR_SOURCE_FILE_ID,
      ) || {};
    const FetchOtherLocalAttributesList =
      OtherLocalAttributesList?.gold_mapping || {};
    const FinalOtherLocalAttributesList = Object.fromEntries(
      Object.entries(FetchOtherLocalAttributesList).filter(
        ([key, value]) => value.length > 0,
      ),
    );
    const OtherLocalAttribuetKeyList =
      Object?.keys(FinalOtherLocalAttributesList) || [];

    removeEmptyColumnForLevelsColumn(
      Final_Dropdowns,
      OtherLocalAttribuetKeyList,
    );
    const { HARBOR_SOURCE_FILE_ID, ...rest } = Final_Dropdowns || {};
    const BRAND_VALUES =
      sourceData?.data?.dropdown?.brands?.find(
        (item) => item.HARBOR_SOURCE_FILE_ID === rowData.HARBOR_SOURCE_FILE_ID,
      ) ?? {};
    const DERIVED_VALUES = BRAND_VALUES?.[SORTED_DROPDOWN_NAME] ?? [];
    const SORTED_BRAND_VALUES =
      DERIVED_VALUES?.length > 0 ? DERIVED_VALUES : [];

    const Updated_Dropdown_Data = {
      ...sourceData?.data?.dropdown,
      ...rest,
      // FILTERED_RB_BRAND: FINAL_FILTERED_RB_BRAND || [],
      // POWER_BRAND: FINAL_POWER_BRAND || [],
      FILTERED_RB_BRAND: SORTED_BRAND_VALUES || [],
      POWER_BRAND: SORTED_BRAND_VALUES || [],
      OTHER_LOCAL_ATTRIBUTE_KEY: OtherLocalAttribuetKeyList,
    };

    updateSourceInputs("data", {
      ...sourceData.data,
      dropdown: { ...Updated_Dropdown_Data },
    });
    setDropDownData(Updated_Dropdown_Data || {});
  }, []);

  const handleRowValueFix = (key, val) => {
    const updated = { ...rowData, [key]: val };

    const allColumns = dropdownData?.table_header_column_list || [];
    const unwantedColumns = dropdownData?.unwanted_table_column || [];

    const Target_Array = allColumns.filter(
      (item) => !unwantedColumns.includes(item.name),
    );

    const targetIndex = Target_Array.findIndex((item) => item.name === key);
    const Sorted_Columns = Target_Array.slice(targetIndex + 1);

    Sorted_Columns.forEach((item) => {
      updated[item.name] = null;
    });

    setRowData(updated);
  };

  const handleOnSelectChange = (key, val, itemName) => {
    if (key && key === "HARBOR_SOURCE_FILE_ID") {
      const SORTED_DROPDOWN_NAME = `${
        SOURCE_NAME || sourceData?.current_source?.value
      }_BRAND`;

      let Final_Dropdowns = {};
      let FINAL_FILTERED_RB_BRAND = [];
      let FINAL_POWER_BRAND = [];
      sourceData?.data?.dropdown?.dropdown?.forEach((item) => {
        // NORMAL DROPDOWN DATA
        const { HARBOR_SOURCE_FILE_ID, ...rest } =
          sourceData?.data?.dropdown?.dropdown?.find((match) => {
            return match.HARBOR_SOURCE_FILE_ID === val;
          }) ?? {};

        // GOLD TABLE DROPDOWN DATA
        const { gold_mapping } =
          sourceData?.data?.dropdown?.gold_table_data?.find(
            (item) => item.HARBOR_SOURCE_FILE_ID === val,
          ) ?? {};

        // OTHER LOCAL ATTRIBUTE DROPDOWN DATA
        const { attributes_map } =
          sourceData?.data?.dropdown?.other_local_attribute_map?.find(
            (match) => {
              return match.HARBOR_SOURCE_FILE_ID === val;
            },
          ) ?? {};

        // GOLD OLT DROPDOWN DATA
        const MATCHING_OLT_GOLD_DROPDOWN =
          sourceData?.data?.dropdown?.gold_table_data_olt?.find((match) => {
            return match.HARBOR_SOURCE_FILE_ID === val;
          }) ?? {};
        const OLT_GOLD_MAPPING = MATCHING_OLT_GOLD_DROPDOWN?.gold_mapping;

        const MATCH = item.HARBOR_SOURCE_FILE_ID === val;

        if (MATCH) {
          if (!gold_mapping || Object.keys(gold_mapping).length === 0) {
            Final_Dropdowns = {
              ...Final_Dropdowns,
            };
          } else {
            // DROPDOWN MAPPING AS PER GOLD TABLE DROPDOWN METADATA
            Object.keys(gold_mapping)?.forEach((gold_item) => {
              const IS_OLT = gold_mapping?.[gold_item]
                ?.toLowerCase()
                ?.includes("olt");
              if (IS_OLT) {
                const OLT_REMOVED_NAME = gold_mapping?.[gold_item]?.replace(
                  /^olt_/i,
                  "",
                );
                Final_Dropdowns = {
                  ...Final_Dropdowns,
                  [gold_item]: attributes_map?.[OLT_REMOVED_NAME ?? ""] || [],
                };
              } else {
                if (gold_mapping?.[gold_item] === SORTED_DROPDOWN_NAME) {
                  FINAL_FILTERED_RB_BRAND =
                    rest?.[gold_mapping?.[gold_item] ?? ""] || [];
                  FINAL_POWER_BRAND =
                    rest?.[gold_mapping?.[gold_item] ?? ""] || [];
                }
                Final_Dropdowns = {
                  ...Final_Dropdowns,
                  [gold_item]: rest?.[gold_mapping?.[gold_item] ?? ""] || [],
                };
              }
            });

            // DROPDOWN MAPPING AS PER GOLD TABLE OLT DROPDOWN METADATA
            Object.keys(OLT_GOLD_MAPPING || {})?.forEach((olt_gold_item) => {
              const IS_OLT = OLT_GOLD_MAPPING?.[olt_gold_item]
                ?.toLowerCase()
                ?.includes("olt");

              if (IS_OLT) {
                const OLT_REMOVED_NAME = OLT_GOLD_MAPPING?.[
                  olt_gold_item
                ]?.replace(/^olt_/i, "");
                Final_Dropdowns = {
                  ...Final_Dropdowns,
                  [olt_gold_item]:
                    attributes_map?.[OLT_REMOVED_NAME ?? ""] || [],
                };
              } else {
                Final_Dropdowns = {
                  ...Final_Dropdowns,
                  [olt_gold_item]:
                    rest?.[OLT_GOLD_MAPPING?.[olt_gold_item] ?? ""] || [],
                };
              }
            });
          }
        }
      });

      // OTHER_LOCAL_ATTRIBUTES
      const OtherLocalAttributesList =
        sourceData?.data?.dropdown?.gold_table_data_olt?.find(
          (item) => item.HARBOR_SOURCE_FILE_ID === val,
        ) || {};
      const FetchOtherLocalAttributesList =
        OtherLocalAttributesList?.gold_mapping || {};
      const FinalOtherLocalAttributesList = Object.fromEntries(
        Object.entries(FetchOtherLocalAttributesList).filter(
          ([key, value]) => value.length > 0,
        ),
      );
      const OtherLocalAttribuetKeyList =
        Object?.keys(FinalOtherLocalAttributesList) || [];

      removeEmptyColumnForLevelsColumn(
        Final_Dropdowns,
        OtherLocalAttribuetKeyList,
      );

      const { HARBOR_SOURCE_FILE_ID, ...rest } = Final_Dropdowns || {};
      const BRAND_VALUES =
        sourceData?.data?.dropdown?.brands?.find(
          (item) => item.HARBOR_SOURCE_FILE_ID === val,
        ) ?? {};
      const DERIVED_VALUES = BRAND_VALUES?.[SORTED_DROPDOWN_NAME] ?? [];
      const SORTED_BRAND_VALUES =
        DERIVED_VALUES?.length > 0 ? DERIVED_VALUES : [];

      const Updated_Dropdown_Data = {
        ...sourceData?.data?.dropdown,
        ...rest,
        // FILTERED_RB_BRAND: FINAL_FILTERED_RB_BRAND || [],
        // POWER_BRAND: FINAL_POWER_BRAND || [],
        FILTERED_RB_BRAND: SORTED_BRAND_VALUES || [],
        POWER_BRAND: SORTED_BRAND_VALUES || [],
        OTHER_LOCAL_ATTRIBUTE_KEY: OtherLocalAttribuetKeyList,
      };

      updateSourceInputs("data", {
        ...sourceData.data,
        dropdown: Updated_Dropdown_Data,
      });
      setDropDownData(Updated_Dropdown_Data || {});
    }
    setRowHasError(false);
    const isArray = Array.isArray(val);

    const formattedValue = isArray
      ? val
          .filter(Boolean) // remove null / undefined
          .map((item) =>
            typeof item === "object" ? (item.value ?? item.label) : item,
          )
          .join(",")
      : (val ?? "");

    const updated = { ...rowData, [key]: formattedValue };

    setUpdatedRowData((prev) => ({
      ...prev,
      [key]: formattedValue,
    }));

    handleDropdownOptions(key, formattedValue, itemName);

    const isAllValuesNull = dropdownData.duplicate_validation_attributes.every(
      (column) =>
        editData?.[column] === null ||
        editData?.[column] === "null" ||
        editData?.[column] === "",
    );

    if (isAllValuesNull) {
      handleRowValueFix(key, formattedValue);
    } else {
      setRowData(updated);
    }
  };

  const handleOnInputChange = (e, itemName) => {
    const ColumnValue = e?.target?.value || "";
    const FinalColumnValue =
      !ColumnValue?.length > 0 &&
      dropdownData?.columns_with_multi_select?.includes(itemName)
        ? e || ""
        : ColumnValue;

    const DROPDOWN_DATA = sourceData?.data?.dropdown || {};
    const ALLOWED_SPECIAL_CHARACTERS =
      DROPDOWN_DATA?.allowed_special_characters || "";
    const hasExplicitDanger = hasDangerousCode(
      ColumnValue,
      ALLOWED_SPECIAL_CHARACTERS,
    );

    if (hasExplicitDanger && !hasExplicitDanger?.isValid) {
      updateAlert({
        open: true,
        message: `${hasExplicitDanger?.error}`,
        severity: "error",
        closeFlag: true,
      });
      return false;
    }

    setRowHasError(false);
    const updatedData = Object.assign({}, rowData, {
      [itemName]: FinalColumnValue,
    });

    setUpdatedRowData((prev) => ({
      ...prev,
      [itemName]: FinalColumnValue,
    }));
    setRowData(updatedData);
  };

  // LEVELS COLUMN SUPPORT FUNCTIONS
  const formatString = (str) => {
    if (!str.includes(",")) return str; // single value → return as is
    return str.split(",").join("','");
  };

  const getDropdownValues = (itemName, currentKey, currentCond) => {
    const CURRENT_CONDITION =
      currentCond && currentCond.length > 0
        ? currentCond
        : currentCondition?.data || [];
    const IS_DEPENDENT_KEY = dropdownData?.dependent_key_list?.keys?.includes(
      currentKey?.value || "",
    );
    const DEPENDENT_COLUMN =
      dropdownData?.dependent_key_list?.dependent_column?.[
        currentKey?.value || ""
      ] || "";
    let options = [];
    if (IS_DEPENDENT_KEY && CURRENT_CONDITION && CURRENT_CONDITION.length > 0) {
      const DEPENDED_COLUMN_KEY_NAME =
        CURRENT_CONDITION?.find?.((item) => item.key === DEPENDENT_COLUMN) ||
        "";

      const DEPENDED_COLUMN_KEY_NAME_VALUE =
        DEPENDED_COLUMN_KEY_NAME?.value
          ?.replace(/','/g, ",")
          .replace(/'/g, "")
          .split(/\s*,\s*/)
          .filter(Boolean) || [];

      let DROPDOWN_OPTIONS = [];
      DEPENDED_COLUMN_KEY_NAME_VALUE?.forEach((key_name) => {
        const Temp_Dropdown_Values =
          dropdownData?.[key_name]?.map((item) => ({
            label: item,
            value: item,
          })) ?? [];
        DROPDOWN_OPTIONS = [...DROPDOWN_OPTIONS, ...Temp_Dropdown_Values];
      });

      options = DROPDOWN_OPTIONS;
    } else {
      const KEY = currentKey?.value || "";
      const DROPDOWN_OPTIONS =
        dropdownData?.[KEY]?.map((item) => ({
          label: item,
          value: item,
        })) ?? [];
      options = DROPDOWN_OPTIONS;
    }
    return options;
  };

  const handleEditingRow = (condition, index) => {
    const CURRENT_CONDITION = {
      index: index,
      data: condition,
    };
    setCurrentCondition(CURRENT_CONDITION);
    setCurrentKey({});
    setCurrentValue([]);
    setNewConditionKey({});
    setNewConditionValue([]);
  };

  const handleAttributeChange = (
    index_of_cond,
    index_of_attr,
    val,
    itemName,
  ) => {
    const CURRENT_VALUE = val?.map((item) => item.value).join(",");
    if (val && val.length > 0) {
      const SORTED = rowData[itemName][index_of_cond].map((item, ind) => {
        return ind === index_of_attr ? { ...item, value: CURRENT_VALUE } : item;
      });

      const updated = rowData[itemName].map((item, ind) => {
        return ind === index_of_cond ? SORTED : item;
      });
      const Final = {
        ...rowData,
        [itemName]: updated,
      };
      if (SORTED?.[index_of_attr]?.key === "OTHER_LOCAL_ATTRIBUTE_KEY") {
        setCurrentCondition({
          index: index_of_cond,
          data: SORTED,
        });
      }

      setRowData(Final);
      setUpdatedRowData((prev) => ({
        ...prev,
        [itemName]: updated,
      }));
    } else {
      const SORTED =
        rowData[itemName]?.[index_of_cond]?.filter((item, ind) => {
          return ind !== index_of_attr;
        }) ?? [];
      const Updated =
        rowData[itemName]?.map((item, ind) => {
          return ind === index_of_cond ? SORTED : item;
        }) ?? [];
      const SORTED_ARRAY = Updated?.filter((item) => item.length > 0);
      const Final = {
        ...rowData,
        [itemName]: SORTED_ARRAY,
      };
      setRowData(Final);
      setUpdatedRowData((prev) => ({
        ...prev,
        [itemName]: SORTED_ARRAY,
      }));
    }
  };

  const addNewAttributeToObjectTypeCol = (index, itemName) => {
    const Current_Key =
      currentKey?.value === "OTHER_LOCAL_ATTRIBUTE_KEY" ||
      currentKey?.value === "OTHER_LOCAL_ATTRIBUTE_VALUE"
        ? formatString(currentKey?.value || "")
        : currentKey?.value || "";

    const Same_Key_Not_Exists =
      rowData?.[itemName]?.[index] && rowData?.[itemName]?.[index].length > 0
        ? rowData?.[itemName]?.[index].every((item) => item.key !== Current_Key)
        : true;

    if (is_Level_Column_Editable && Same_Key_Not_Exists) {
      const CURRENT_VALUE =
        currentKey?.value === "OTHER_LOCAL_ATTRIBUTE_KEY" ||
        currentKey?.value === "OTHER_LOCAL_ATTRIBUTE_VALUE"
          ? formatString(
              currentValue?.map((item) => item.value)?.join(",") ?? "",
            )
          : (currentValue?.map((item) => item.value)?.join(",") ?? "");

      const SORTED_ATTRIBUTE_LIST = [
        ...rowData?.[itemName]?.[index],
        { key: Current_Key, value: CURRENT_VALUE },
      ];
      const updated = rowData?.[itemName]?.map((item, ind) => {
        return ind === index ? SORTED_ATTRIBUTE_LIST : item;
      });
      const Final = {
        ...rowData,
        [itemName]: updated,
      };
      setRowData(Final);
      setUpdatedRowData((prev) => ({
        ...prev,
        [itemName]: updated,
      }));
      const CURRENT_CONDITION = {
        index: index,
        data: SORTED_ATTRIBUTE_LIST.map((item) => {
          return { ...item, value: item?.value };
        }),
      };
      setCurrentCondition(CURRENT_CONDITION);
      setCurrentKey({});
      setCurrentValue([]);
    } else {
      updateAlert({
        open: true,
        message: "The selected key already exist",
        severity: "error",
        closeFlag: true,
      });
    }
  };

  const removeAttributeFromObjectTypeCol = (
    index_of_cond,
    index_of_attr,
    itemName,
  ) => {
    const SORTED =
      rowData?.[itemName]?.[index_of_cond]?.filter(
        (item, index) => index !== index_of_attr,
      ) ?? [];

    const CURRENT_CONDITION = {
      index: index_of_cond,
      data: SORTED?.map((item) => {
        return { ...item, value: item?.value };
      }),
    };
    setCurrentCondition(CURRENT_CONDITION);

    let updated;

    if (SORTED && SORTED.length > 0) {
      updated = rowData[itemName].map((item, ind) => {
        return ind === index_of_cond ? SORTED : item;
      });
    } else {
      updated = rowData[itemName].filter((item, ind) => {
        return ind !== index_of_cond;
      });
    }

    const Final = {
      ...rowData,
      [itemName]: updated,
    };
    setRowData(Final);
    setUpdatedRowData((prev) => ({
      ...prev,
      [itemName]: updated,
    }));
  };

  const handleAddNewCondition = () => {
    if (is_New_Condition_Valid) {
      const CURRENT_KEY =
        newConditionKey?.value === "OTHER_LOCAL_ATTRIBUTE_KEY" ||
        newConditionKey?.value === "OTHER_LOCAL_ATTRIBUTE_VALUE"
          ? formatString(newConditionKey?.value || "")
          : newConditionKey?.value || "";
      const CURRENT_VALUE =
        newConditionKey?.value === "OTHER_LOCAL_ATTRIBUTE_KEY" ||
        newConditionKey?.value === "OTHER_LOCAL_ATTRIBUTE_VALUE"
          ? formatString(
              newConditionValue?.map((item) => item.value).join(",") ?? "",
            )
          : (newConditionValue?.map((item) => item.value).join(",") ?? "");

      const NEW = [{ key: CURRENT_KEY, value: CURRENT_VALUE }];

      const updated = [...(rowData?.LEVELS || []), NEW];

      const Final = {
        ...rowData,
        LEVELS: updated,
      };

      setRowData(Final);

      setUpdatedRowData((prev) => ({
        ...prev,
        LEVELS: updated,
      }));

      setNewConditionKey({});
      setNewConditionValue([]);
      setCurrentCondition({ index: rowData?.LEVELS?.length || 0, data: NEW });
    } else {
      updateAlert({
        open: true,
        message: "Please fill all the values",
        severity: "error",
        closeFlag: true,
      });
    }
  };

  const removeConditionFromObjectTypeCol = (index, itemName) => {
    const updated = rowData[itemName].filter((item, ind) => {
      return ind !== index;
    });

    const Final = {
      ...rowData,
      [itemName]: updated,
    };
    setRowData(Final);
    setUpdatedRowData((prev) => ({
      ...prev,
      [itemName]: updated,
    }));
  };

  const formattedData = (data) => {
    if (!Array.isArray(data)) return "";

    return data
      .map((item, index) => {
        if (item?.key && item?.value !== undefined) {
          const formattedValue = String(item.value)
            .split(/\s*,\s*/)
            .map((v) => v.trim())
            .join(",");

          return `${index + 1}) ${item.key} : ${formattedValue}`;
        }

        return "";
      })
      .filter(Boolean)
      .join("\n");
  };

  // LEVELS COLUMN KEY AND VALUE CHANGE HANDLER
  const updateKeyforAddConditionMethod = (key) => {
    const IS_DEPENDENT_KEY = dropdownData?.dependent_key_list?.keys?.includes(
      key?.value || "",
    );
    const DEPENDENT_COLUMN =
      dropdownData?.dependent_key_list?.dependent_column?.[key?.value] || "";
    if (!IS_DEPENDENT_KEY) {
      setNewConditionKey(key);
      setNewConditionValue([]);
    } else {
      setNewConditionKey({});
      setNewConditionValue([]);
      updateAlert({
        open: true,
        message: `${key?.value || ""} is dependent column. It cannot be added without its dependency column ${DEPENDENT_COLUMN}. Please select a non-dependent key or add the dependency column first.`,
        severity: "error",
        closeFlag: true,
      });
    }
  };

  const updateKeyForAddNewAttributeMethod = (key) => {
    setCurrentKey(key);
    setCurrentValue([]);
  };

  const isOtherReckittBrandsApplicable = (col) => {
    const is_single_insert_applicable_column =
      dropdownData?.is_single_insert_applicable_columns?.includes(col);
    if (!is_single_insert_applicable_column) return false;
    const Is_Single_Insert =
      dropdownData?.is_single_insert_applicable_values?.includes(
        editData?.[col],
      );
    if (wholeRowData.isNewData && Is_Single_Insert) return false;
    if (dropdownData?.is_single_insert_dependent_columns?.includes(col)) {
      const result = isOtherReckittBrandsApplicable("POWER_BRAND");
      if (result) return true;
      return false;
    }
    if (Is_Single_Insert) return true;
    return false;
  };

  return (
    <div>
      <div className="table-fields-container">
        {/* Content */}
        {Edit_Column_Module?.filter(
          (heading) => heading.type !== "object",
        )?.map((item, i) => {
          if (dropdownData?.unwanted_table_column.includes(item.name))
            return null;
          return (
            <div style={{ width: "95%" }} key={`model-${i}`}>
              {item.type === "select" || item.type === "multi_select" ? (
                item.isEditable ? (
                  item.type !== "multi_select" ? (
                    <>
                      {dropdownData?.columns_with_other_options?.includes?.(
                        item?.name || "",
                      ) ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label className="label-style" htmlFor={item.name}>
                            {item?.label || ""}
                          </label>
                          <DropdownWithOther
                            options={
                              dropdownOptions?.[item.name] &&
                              dropdownOptions?.[item.name]?.length > 0
                                ? is_Other_Reckit_Brands_Not_Applicable
                                  ? dropdownOptions?.[item.name]?.filter(
                                      (val) =>
                                        val !== null &&
                                        val !== undefined &&
                                        val !== "" &&
                                        !dropdownData?.is_single_insert_applicable_values?.includes(
                                          val,
                                        ),
                                    )
                                  : dropdownOptions?.[item.name]?.filter(
                                      (val) =>
                                        val !== null &&
                                        val !== undefined &&
                                        val !== "",
                                    )
                                : []
                            }
                            isMultiSelect={dropdownData?.columns_with_multi_select?.includes(
                              item.name,
                            )}
                            onSelectChange={(key, val) => {
                              handleOnSelectChange(key, val, item.name);
                            }}
                            handleOnSelectChange={handleOnSelectChange}
                            setRbBrandValues={setRbBrandValues}
                            onInputChange={handleOnInputChange}
                            item={item}
                            setRowData={setRowData}
                            rowData={rowData}
                            editData={editData}
                            sourceData={sourceData}
                            rowHasError={rowHasError}
                            setRowHasError={setRowHasError}
                            errorMessage={errorMessage}
                            tableName={tableName}
                            allRowsData={allRowsData}
                            updateSourceInputs={updateSourceInputs}
                            readonly={isOtherReckittBrandsApplicable(item.name)}
                          />
                        </div>
                      ) : (
                        <CustomSelect
                          errorMessage={errorMessage}
                          classes={{
                            ...selectClasses,
                          }}
                          tableName={tableName}
                          name={item.name}
                          onChange={(key, val) => {
                            handleOnSelectChange(key, val, item.name);
                          }}
                          options={
                            dropdownOptions?.[item.name] &&
                            dropdownOptions?.[item.name]?.length > 0
                              ? is_Other_Reckit_Brands_Not_Applicable
                                ? dropdownOptions?.[item.name]?.filter(
                                    (val) =>
                                      val !== null &&
                                      val !== undefined &&
                                      val !== "" &&
                                      !dropdownData?.is_single_insert_applicable_values?.includes(
                                        val,
                                      ),
                                  )
                                : dropdownOptions?.[item.name]?.filter(
                                    (val) =>
                                      val !== null &&
                                      val !== undefined &&
                                      val !== "",
                                  )
                              : []
                          }
                          customStyles={customStyles}
                          value={
                            rowData[item.name] === null ||
                            rowData[item.name] === "null"
                              ? ""
                              : rowData[item.name]
                          }
                          error={item.error}
                          selectMessage={item.label}
                          validation={item.validation}
                          readonly={isOtherReckittBrandsApplicable(item.name)}
                          showLabel={true}
                          derivedOptions={{}}
                          sourceData={sourceData}
                        />
                      )}
                    </>
                  ) : dropdownData?.columns_with_other_options?.includes?.(
                      item?.name || "",
                    ) ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label className="label-style" htmlFor={item.name}>
                        {item?.label || ""}
                      </label>
                      <DropdownWithOther
                        options={
                          dropdownOptions?.[item.name] &&
                          dropdownOptions?.[item.name]?.length > 0
                            ? is_Other_Reckit_Brands_Not_Applicable
                              ? dropdownOptions?.[item.name]?.filter(
                                  (val) =>
                                    val !== null &&
                                    val !== undefined &&
                                    val !== "" &&
                                    !dropdownData?.is_single_insert_applicable_values?.includes(
                                      val,
                                    ),
                                )
                              : dropdownOptions?.[item.name]?.filter(
                                  (val) =>
                                    val !== null &&
                                    val !== undefined &&
                                    val !== "",
                                )
                            : []
                        }
                        readonly={isOtherReckittBrandsApplicable(item.name)}
                        isMultiSelect={dropdownData?.columns_with_multi_select?.includes(
                          item.name,
                        )}
                        onSelectChange={(key, val) => {
                          handleOnSelectChange(key, val, item.name);
                        }}
                        handleOnSelectChange={handleOnSelectChange}
                        setRbBrandValues={setRbBrandValues}
                        onInputChange={handleOnInputChange}
                        item={item}
                        setRowData={setRowData}
                        rowData={rowData}
                        editData={editData}
                        sourceData={sourceData}
                        rowHasError={rowHasError}
                        setRowHasError={setRowHasError}
                        errorMessage={errorMessage}
                        tableName={tableName}
                        allRowsData={allRowsData}
                        updateSourceInputs={updateSourceInputs}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        gap: "3px",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          color: "#5d6063",
                        }}
                      >
                        {item.label}
                      </label>
                      <Autocomplete
                        multiple
                        disableCloseOnSelect
                        options={
                          is_Other_Reckit_Brands_Not_Applicable
                            ? dropdownOptions?.[item.name]?.filter(
                                (val) =>
                                  val !== null &&
                                  val !== undefined &&
                                  val !== "" &&
                                  !dropdownData?.is_single_insert_applicable_values?.includes(
                                    val,
                                  ),
                              )
                            : dropdownOptions?.[item.name]?.filter(Boolean) ||
                              []
                        }
                        disabled={isOtherReckittBrandsApplicable(item.name)}
                        value={
                          rowData[item.name] === null ||
                          rowData[item.name] === "null"
                            ? []
                            : rowData[item.name]
                                .split(/\s*,\s*/)
                                .map((v) => v.trim())
                        }
                        onChange={(e, newValue) => {
                          handleOnSelectChange(item.name, newValue, item.name);
                        }}
                        getOptionLabel={(option) => option}
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              checked={selected}
                              sx={{ padding: "2px", transform: "scale(0.9)" }}
                            />
                            {option}
                          </li>
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              label={option}
                              size="small"
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => <TextField {...params} />}
                        sx={{
                          fontSize: "12px",

                          "& .MuiAutocomplete-inputRoot": {
                            minHeight: "fit-content",
                            minWidth: "280px",
                            width: "100%",
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                          },

                          "& .MuiAutocomplete-tag": {
                            margin: "2px",
                          },
                        }}
                        slotProps={{
                          popper: {
                            sx: {
                              "& .MuiAutocomplete-listbox": {
                                fontSize: "12px",
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  )
                ) : wholeRowData.isNewData ? (
                  item.type !== "multi_select" ? (
                    <>
                      {dropdownData?.columns_with_other_options?.includes?.(
                        item?.name || "",
                      ) ? (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <label className="label-style" htmlFor={item.name}>
                            {item?.label || ""}
                          </label>
                          <DropdownWithOther
                            options={
                              dropdownOptions?.[item.name] &&
                              dropdownOptions?.[item.name]?.length > 0
                                ? is_Other_Reckit_Brands_Not_Applicable
                                  ? dropdownOptions?.[item.name]?.filter(
                                      (val) =>
                                        val !== null &&
                                        val !== undefined &&
                                        val !== "" &&
                                        !dropdownData?.is_single_insert_applicable_values?.includes(
                                          val,
                                        ),
                                    )
                                  : dropdownOptions?.[item.name]?.filter(
                                      (val) =>
                                        val !== null &&
                                        val !== undefined &&
                                        val !== "",
                                    )
                                : []
                            }
                            readonly={isOtherReckittBrandsApplicable(item.name)}
                            isMultiSelect={dropdownData?.columns_with_multi_select?.includes(
                              item.name,
                            )}
                            onSelectChange={(key, val) => {
                              handleOnSelectChange(key, val, item.name);
                            }}
                            handleOnSelectChange={handleOnSelectChange}
                            setRbBrandValues={setRbBrandValues}
                            onInputChange={handleOnInputChange}
                            item={item}
                            setRowData={setRowData}
                            rowData={rowData}
                            editData={editData}
                            sourceData={sourceData}
                            rowHasError={rowHasError}
                            setRowHasError={setRowHasError}
                            errorMessage={errorMessage}
                            tableName={tableName}
                            allRowsData={allRowsData}
                            updateSourceInputs={updateSourceInputs}
                          />
                        </div>
                      ) : (
                        <CustomSelect
                          errorMessage={errorMessage}
                          classes={{
                            ...selectClasses,
                          }}
                          tableName={tableName}
                          readonly={isOtherReckittBrandsApplicable(item.name)}
                          name={item.name}
                          onChange={(key, val) => {
                            handleOnSelectChange(key, val, item.name);
                          }}
                          options={
                            dropdownOptions?.[item.name] &&
                            dropdownOptions?.[item.name]?.length > 0
                              ? is_Other_Reckit_Brands_Not_Applicable
                                ? dropdownOptions?.[item.name]?.filter(
                                    (val) =>
                                      val !== null &&
                                      val !== undefined &&
                                      val !== "" &&
                                      !dropdownData?.is_single_insert_applicable_values?.includes(
                                        val,
                                      ),
                                  )
                                : dropdownOptions?.[item.name]?.filter(
                                    (val) =>
                                      val !== null &&
                                      val !== undefined &&
                                      val !== "",
                                  )
                              : []
                          }
                          customStyles={customStyles}
                          value={
                            rowData[item.name] === null ||
                            rowData[item.name] === "null"
                              ? ""
                              : rowData[item.name]
                          }
                          error={item.error}
                          selectMessage={item.label}
                          validation={item.validation}
                          showLabel={true}
                          derivedOptions={{}}
                          sourceData={sourceData}
                        />
                      )}
                    </>
                  ) : dropdownData?.columns_with_other_options?.includes?.(
                      item?.name || "",
                    ) ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <label className="label-style" htmlFor={item.name}>
                        {item?.label || ""}
                      </label>
                      <DropdownWithOther
                        options={
                          dropdownOptions?.[item.name] &&
                          dropdownOptions?.[item.name]?.length > 0
                            ? is_Other_Reckit_Brands_Not_Applicable
                              ? dropdownOptions?.[item.name]?.filter(
                                  (val) =>
                                    val !== null &&
                                    val !== undefined &&
                                    val !== "" &&
                                    !dropdownData?.is_single_insert_applicable_values?.includes(
                                      val,
                                    ),
                                )
                              : dropdownOptions?.[item.name]?.filter(
                                  (val) =>
                                    val !== null &&
                                    val !== undefined &&
                                    val !== "",
                                )
                            : []
                        }
                        readonly={isOtherReckittBrandsApplicable(item.name)}
                        handleOnSelectChange={handleOnSelectChange}
                        isMultiSelect={dropdownData?.columns_with_multi_select?.includes(
                          item.name,
                        )}
                        onSelectChange={(key, val) => {
                          handleOnSelectChange(key, val, item.name);
                        }}
                        setRbBrandValues={setRbBrandValues}
                        onInputChange={handleOnInputChange}
                        item={item}
                        setRowData={setRowData}
                        rowData={rowData}
                        editData={editData}
                        sourceData={sourceData}
                        rowHasError={rowHasError}
                        setRowHasError={setRowHasError}
                        errorMessage={errorMessage}
                        tableName={tableName}
                        allRowsData={allRowsData}
                        updateSourceInputs={updateSourceInputs}
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        gap: "3px",
                        width: "100%",
                      }}
                    >
                      <label
                        style={{
                          fontSize: "12px",
                          color: "#5d6063",
                        }}
                      >
                        {item.label}
                      </label>
                      <Autocomplete
                        multiple
                        disableCloseOnSelect
                        options={
                          is_Other_Reckit_Brands_Not_Applicable
                            ? dropdownOptions?.[item.name]?.filter(
                                (val) =>
                                  val !== null &&
                                  val !== undefined &&
                                  val !== "" &&
                                  !dropdownData?.is_single_insert_applicable_values?.includes(
                                    val,
                                  ),
                              )
                            : dropdownOptions?.[item.name]?.filter(Boolean) ||
                              []
                        }
                        disabled={isOtherReckittBrandsApplicable(item.name)}
                        value={
                          rowData[item.name] === null ||
                          rowData[item.name] === "null"
                            ? []
                            : rowData[item.name]
                                .split(/\s*,\s*/)
                                .map((v) => v.trim())
                        }
                        onChange={(e, newValue) => {
                          handleOnSelectChange(e, newValue, item.name);
                        }}
                        getOptionLabel={(option) => option}
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              checked={selected}
                              sx={{ padding: "2px", transform: "scale(0.9)" }}
                            />
                            {option}
                          </li>
                        )}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              label={option}
                              size="small"
                              {...getTagProps({ index })}
                            />
                          ))
                        }
                        renderInput={(params) => <TextField {...params} />}
                        sx={{
                          fontSize: "12px",

                          "& .MuiAutocomplete-inputRoot": {
                            minHeight: "fit-content",
                            minWidth: "280px",
                            width: "100%",
                            alignItems: "flex-start",
                            flexWrap: "wrap",
                          },

                          "& .MuiAutocomplete-tag": {
                            margin: "2px",
                          },
                        }}
                        slotProps={{
                          popper: {
                            sx: {
                              "& .MuiAutocomplete-listbox": {
                                fontSize: "12px",
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  )
                ) : (
                  <>
                    <div>
                      <h3 style={{ fontSize: "12px", color: "#5d6063" }}>
                        {item.label}
                      </h3>
                      <p style={{ fontSize: "12px", color: "black" }}>
                        {rowData[item.name]?.length > 0
                          ? rowData[item.name]
                          : ""}
                      </p>
                    </div>
                  </>
                )
              ) : item.type === "input" ? (
                <>
                  <Input
                    errorMessage={errorMessage}
                    rowHasError={rowHasError}
                    columnDataArr={(allRowsData || []).map(
                      (obj) => obj.rowData[item.name],
                    )}
                    tableName={tableName}
                    classes={{ ...inputClasses }}
                    type={item.type}
                    name={item.name}
                    onChange={(e) => {
                      handleOnInputChange(e, item.name);
                    }}
                    readonly={
                      (item.isValidation &&
                        rowData[item.validation] === null) ||
                      rowData[item.validation] === ""
                        ? true
                        : false
                    }
                    value={
                      rowData[item.name] != null
                        ? typeof rowData[item.name] === "object"
                          ? JSON.stringify(rowData[item.name])
                          : String(rowData[item.name])
                        : ""
                    }
                    item={item.name}
                    childHasError={(bool) => setRowHasError(bool)}
                    error={item.error}
                    validation={validation}
                  />
                  {!wholeRowData.isValidated && wholeRowData.errorMessage && (
                    <p className="error-message">{wholeRowData.errorMessage}</p>
                  )}
                </>
              ) : (
                <>
                  <div>
                    <h3 style={{ fontSize: "12px", color: "#5d6063" }}>
                      {item.label}
                    </h3>
                    <p style={{ fontSize: "12px", color: "black" }}>
                      {rowData[item.name]?.length > 0 ? rowData[item.name] : ""}
                    </p>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>

      {Edit_Column_Module?.filter((item) => item.type === "object")?.map(
        (item) => {
          return (
            <div>
              {/* LABEL */}
              <h3
                style={{
                  fontSize: "12px",
                  color: "#5d6063",
                  marginTop: "32px",
                }}
              >
                {item?.label || ""}
              </h3>

              {/* CONTENT */}
              {rowData?.[item.name] && rowData?.[item.name]?.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    gap: "8px",
                    marginTop: "16px",
                  }}
                >
                  {/* TABS */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      height: "300px",
                      overflowY: "auto",
                    }}
                  >
                    {rowData[item.name].map((condition, index) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            padding: " 6px 10px",
                            backgroundColor:
                              currentCondition &&
                              currentCondition.index === index
                                ? "rgba(240, 240, 240, .9)"
                                : currentCondition &&
                                    currentCondition.length === 0 &&
                                    index === 0
                                  ? "rgba(240, 240, 240, .9)"
                                  : "transparent",
                          }}
                        >
                          {/* CONDITION TEXT */}
                          <p
                            style={{
                              fontSize: "12px",
                              color: "black",
                              border: "1px solid #e0e0e0",
                              padding: "4px 4px",
                              width: "400px",
                              minHeight: "35px",
                              height: "fit-content",
                              cursor: "pointer",
                              whiteSpace: "pre-wrap",
                            }}
                            onClick={() => handleEditingRow(condition, index)}
                          >
                            {condition && condition.length > 0
                              ? formattedData(condition)
                              : ""}
                          </p>

                          {/* ACTIONS */}
                          <div style={{ display: "flex", gap: "10px" }}>
                            <i
                              className="material-icons-outlined "
                              onClick={() =>
                                removeConditionFromObjectTypeCol(
                                  index,
                                  item.name,
                                )
                              }
                              style={{ cursor: "pointer", color: "red" }}
                            >
                              delete
                            </i>
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  {/* EDIT BAR */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* INITIAL CONDITION */}
                    {currentCondition && currentCondition.length === 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {/* EXISTING ATTRIBUTE DROPDOWNS START */}
                        {rowData[item.name]?.[0] &&
                          rowData[item.name]?.[0]?.length > 0 &&
                          rowData[item.name]?.[0].map((attribute, index) => {
                            // --- KEY OPTIONS ---
                            const KEY = {
                              label: attribute.key,
                              value: attribute.key,
                            };
                            const KEY_OPTIONS =
                              dropdownData?.[item.name]?.key?.length > 0
                                ? dropdownData[item.name].key
                                : [];

                            // --- VALUE OPTIONS ---
                            const VALUE =
                              rowData[item.name]?.[0][index]?.value?.length > 0
                                ? rowData[item.name]?.[0][index]?.value
                                    ?.replace(/','/g, ",")
                                    .replace(/'/g, "")
                                    .split(/\s*,\s*/)
                                    .filter(Boolean) // removes empty values
                                    .map((val) => ({
                                      label: val,
                                      value: val,
                                    }))
                                : [];

                            const CURRENT_CONDITION =
                              rowData?.[item.name]?.[0] || [];

                            return (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  gap: "8px",
                                  marginLeft: "20px",
                                  width: "550px",
                                  height: "fit-content",
                                }}
                              >
                                {/* KEY */}
                                <div style={{ width: "100%" }}>
                                  <Autocomplete
                                    disableClearable
                                    options={levelColKeys || []}
                                    value={KEY}
                                    getOptionLabel={(option) =>
                                      option.label || ""
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                      option.value === value.value
                                    }
                                    renderOption={(
                                      props,
                                      option,
                                      { selected },
                                    ) => {
                                      return <li {...props}>{option.label}</li>;
                                    }}
                                    renderTags={(value, getTagProps) =>
                                      value.map((option, index) => (
                                        <Chip
                                          key={option.value}
                                          label={option.label}
                                          {...getTagProps({ index })}
                                          size="small"
                                        />
                                      ))
                                    }
                                    sx={{
                                      fontSize: "14px", // base font size
                                      "& .MuiInputBase-root": {
                                        padding: "2px 10px 2px 10px",
                                        fontSize: "12px",
                                      },
                                      "& .MuiInputLabel-root": {
                                        fontSize: "14px",
                                      },
                                      "& .MuiAutocomplete-endAdornment": {
                                        top: "calc(100% - 18px)", // center the dropdown icon
                                      },
                                    }}
                                    slotProps={{
                                      popper: {
                                        sx: {
                                          "& .MuiAutocomplete-paper": {
                                            boxShadow:
                                              "0 2px 8px rgba(0,0,0,0.15)",
                                            borderRadius: "8px",
                                          },
                                          "& .MuiAutocomplete-listbox": {
                                            padding: "4px 0",
                                            fontSize: "12px",
                                          },
                                          "& .MuiAutocomplete-option": {
                                            padding: "4px 6px",
                                            margin: "0px 4px",
                                            borderRadius: "2px",
                                            cursor: "pointer",
                                            transition: "background 0.15s ease",
                                          },
                                          "& .MuiAutocomplete-option:hover": {
                                            backgroundColor: "#f0f0f0",
                                          },
                                          "& .MuiAutocomplete-option[aria-selected='true']":
                                            {
                                              backgroundColor:
                                                "transparent !important",
                                            },
                                          "& .MuiAutocomplete-option.Mui-focused":
                                            {
                                              backgroundColor:
                                                "#f5f5f5 !important",
                                            },
                                        },
                                      },
                                    }}
                                    open={false} // 👈 force close always
                                    onOpen={(e) => e.stopPropagation()} // block opening
                                    readOnly
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        inputProps={{
                                          ...params.inputProps,
                                          readOnly: true,
                                        }}
                                        style={{ border: "none" }}
                                      />
                                    )}
                                  />
                                </div>
                                <span style={{ width: "10px" }}>:</span>
                                {/* VALUE */}
                                <div style={{ width: "100%" }}>
                                  <Autocomplete
                                    multiple
                                    disableCloseOnSelect
                                    options={
                                      getDropdownValues(
                                        item.name,
                                        KEY,
                                        CURRENT_CONDITION,
                                      ) || []
                                    }
                                    value={VALUE}
                                    onChange={(key, val) => {
                                      handleAttributeChange(
                                        0,
                                        index,
                                        val,
                                        item.name,
                                      );
                                    }}
                                    getOptionLabel={(option) =>
                                      option.label || ""
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                      option.value === value.value
                                    }
                                    renderOption={(
                                      props,
                                      option,
                                      { selected },
                                    ) => {
                                      let isExisting = VALUE.some((col) => {
                                        return col.value === option.value;
                                      });
                                      return (
                                        <li {...props}>
                                          <Checkbox
                                            checked={isExisting}
                                            sx={{
                                              transform: "scale(.9)", // scale up (1 = default size)
                                              padding: "2px", // optional: reduce padding
                                            }}
                                          />
                                          {option.label}
                                        </li>
                                      );
                                    }}
                                    renderTags={(value, getTagProps) =>
                                      value.map((option, index) => (
                                        <Chip
                                          key={option.value}
                                          label={option.label}
                                          {...getTagProps({ index })}
                                          size="small"
                                        />
                                      ))
                                    }
                                    sx={{
                                      fontSize: "14px",

                                      // FIXED HEIGHT + INTERNAL SCROLL
                                      "& .MuiAutocomplete-inputRoot": {
                                        boxSizing: "border-box",
                                        minHeight: "38px",
                                        maxHeight: "auto",
                                        overflowY: "auto",
                                        paddingRight: "28px !important", // space for dropdown icon
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: "flex-start",
                                      },

                                      "& .MuiAutocomplete-tag": {
                                        margin: "2px",
                                      },

                                      // SCROLLBAR STYLE
                                      "& .MuiAutocomplete-inputRoot::-webkit-scrollbar":
                                        {
                                          width: "6px",
                                        },
                                      "& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb":
                                        {
                                          backgroundColor: "#ccc",
                                          borderRadius: "10px",
                                        },

                                      "& .MuiInputBase-root": {
                                        fontSize: "12px",
                                        padding: "2px 10px",
                                      },
                                    }}
                                    slotProps={{
                                      popper: {
                                        sx: {
                                          "& .MuiAutocomplete-listbox": {
                                            fontSize: "12px", // ⬅️ dropdown font size
                                            padding: "2px 0",
                                          },
                                          "& .MuiAutocomplete-option": {
                                            padding: "4px 6px",
                                          },
                                        },
                                      },
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        style={{ border: "none" }}
                                      />
                                    )}
                                  />
                                </div>
                                {/* ACTION BUTTON */}
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "5px",
                                    backgroundColor: "white",
                                    padding: "4px 8px 2px 8px",
                                    borderRadius: "4px",
                                    height: "35px",
                                    marginTop: "2px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    removeAttributeFromObjectTypeCol(
                                      0,
                                      index,
                                      item.name,
                                    )
                                  }
                                >
                                  <div>
                                    <i
                                      className="material-icons-outlined "
                                      style={{
                                        color: "red",
                                        marginTop: "5px",
                                        fontWeight: "600",
                                        cursor: "pointer",
                                      }}
                                    >
                                      do_not_disturb_on
                                    </i>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        {/* EXISTING ATTRIBUTE DROPDOWNS END */}

                        {/* NEW ATTRIBUTE DROPDOWNS START */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "start",
                            gap: "8px",
                            marginLeft: "20px",
                            width: "582px",
                            height: "fit-content",
                          }}
                        >
                          {/* KEY */}
                          <div style={{ width: "100%" }}>
                            <Autocomplete
                              disableClearable
                              options={levelColKeys || []}
                              value={currentKey || null}
                              onChange={(key, val) => {
                                updateKeyForAddNewAttributeMethod(val);
                              }}
                              getOptionLabel={(option) => option.label || ""}
                              isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                              }
                              renderOption={(props, option, { selected }) => {
                                return <li {...props}>{option.label}</li>;
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    key={option.value}
                                    label={option.label}
                                    {...getTagProps({ index })}
                                    size="small"
                                  />
                                ))
                              }
                              sx={{
                                fontSize: "14px", // base font size
                                "& .MuiInputBase-root": {
                                  padding: "2px 10px 2px 10px",
                                  fontSize: "12px",
                                },
                                "& .MuiInputLabel-root": {
                                  fontSize: "14px",
                                },
                                "& .MuiAutocomplete-endAdornment": {
                                  top: "calc(100% - 18px)", // center the dropdown icon
                                },
                              }}
                              slotProps={{
                                popper: {
                                  sx: {
                                    "& .MuiAutocomplete-paper": {
                                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                      borderRadius: "8px",
                                    },
                                    "& .MuiAutocomplete-listbox": {
                                      padding: "4px 0",
                                      fontSize: "12px",
                                    },
                                    "& .MuiAutocomplete-option": {
                                      padding: "4px 6px",
                                      margin: "0px 4px",
                                      borderRadius: "2px",
                                      cursor: "pointer",
                                      transition: "background 0.15s ease",
                                    },
                                    "& .MuiAutocomplete-option:hover": {
                                      backgroundColor: "#f0f0f0",
                                    },
                                    "& .MuiAutocomplete-option[aria-selected='true']":
                                      {
                                        backgroundColor:
                                          "transparent !important",
                                      },
                                    "& .MuiAutocomplete-option.Mui-focused": {
                                      backgroundColor: "#f5f5f5 !important",
                                    },
                                  },
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  style={{ border: "none" }}
                                />
                              )}
                            />
                          </div>
                          <span style={{ width: "10px" }}>:</span>
                          {/* VALUE */}
                          <div style={{ width: "100%" }}>
                            <Autocomplete
                              multiple
                              disableCloseOnSelect
                              options={getDropdownValues(item.name, currentKey)}
                              value={currentValue || null}
                              onChange={(key, val) => {
                                setCurrentValue(val);
                              }}
                              getOptionLabel={(option) => option.label || ""}
                              isOptionEqualToValue={(option, value) =>
                                option.value === value.value
                              }
                              renderOption={(props, option, { selected }) => {
                                let isExisting =
                                  currentValue?.some((col) => {
                                    return col.value === option.value;
                                  }) ?? false;
                                return (
                                  <li {...props}>
                                    <Checkbox
                                      checked={isExisting}
                                      sx={{
                                        transform: "scale(.9)", // scale up (1 = default size)
                                        padding: "2px", // optional: reduce padding
                                      }}
                                    />
                                    {option.label}
                                  </li>
                                );
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    key={option.value}
                                    label={option.label}
                                    {...getTagProps({ index })}
                                    size="small"
                                  />
                                ))
                              }
                              sx={{
                                fontSize: "14px",

                                // FIXED HEIGHT + INTERNAL SCROLL
                                "& .MuiAutocomplete-inputRoot": {
                                  boxSizing: "border-box",
                                  minHeight: "38px",
                                  maxHeight: "auto",
                                  overflowY: "auto",
                                  paddingRight: "28px !important", // space for dropdown icon
                                  display: "flex",
                                  flexWrap: "wrap",
                                  alignItems: "flex-start",
                                },

                                "& .MuiAutocomplete-tag": {
                                  margin: "2px",
                                },

                                // SCROLLBAR STYLE
                                "& .MuiAutocomplete-inputRoot::-webkit-scrollbar":
                                  {
                                    width: "6px",
                                  },
                                "& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb":
                                  {
                                    backgroundColor: "#ccc",
                                    borderRadius: "10px",
                                  },

                                "& .MuiInputBase-root": {
                                  fontSize: "12px",
                                  padding: "2px 10px",
                                },
                              }}
                              slotProps={{
                                popper: {
                                  sx: {
                                    "& .MuiAutocomplete-listbox": {
                                      fontSize: "12px", // ⬅️ dropdown font size
                                      padding: "2px 0",
                                    },
                                    "& .MuiAutocomplete-option": {
                                      padding: "4px 6px",
                                    },
                                  },
                                },
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  style={{ border: "none" }}
                                />
                              )}
                            />
                          </div>
                          {/* ACTION BUTTON */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "5px",
                              backgroundColor: "#46596a",
                              padding: "4px 8px 2px 8px",
                              borderRadius: "4px",
                              height: "35px",
                              marginTop: "2px",
                              cursor: is_Level_Column_Editable
                                ? "pointer"
                                : "not-allowed",
                            }}
                            onClick={() =>
                              addNewAttributeToObjectTypeCol(0, item.name)
                            }
                          >
                            <div>
                              <i
                                className="material-icons-outlined "
                                style={{
                                  color: "white",
                                  marginTop: "5px",
                                  cursor: is_Level_Column_Editable
                                    ? "pointer"
                                    : "not-allowed",
                                }}
                              >
                                add_circle
                              </i>
                            </div>
                            <div
                              style={{
                                color: "white",
                                fontSize: "13px",
                              }}
                            >
                              Add
                            </div>
                          </div>
                        </div>
                        {/* NEW ATTRIBUTE DROPDOWNS END*/}
                      </div>
                    )}

                    {/* AS PER SELECTION */}
                    {currentCondition &&
                      Object.keys(currentCondition).length > 0 &&
                      currentCondition.data.length > 0 && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "10px",
                          }}
                        >
                          {/* EXISTING ATTRIBUTE DROPDOWNS START */}
                          {rowData[item.name]?.[currentCondition.index] &&
                            rowData[item.name]?.[currentCondition.index]
                              ?.length > 0 &&
                            rowData[item.name]?.[currentCondition.index].map(
                              (cond, index) => {
                                // KEY OPTIONS
                                const KEY = {
                                  label: cond.key,
                                  value: cond.key,
                                };
                                const KEY_OPTIONS =
                                  dropdownData?.[item.name]?.key?.length > 0
                                    ? dropdownData[item.name].key
                                    : [];

                                // --- VALUE OPTIONS ---
                                const VALUE =
                                  cond?.value?.length > 0
                                    ? cond?.value
                                        ?.replace(/','/g, ",")
                                        .replace(/'/g, "")
                                        .split(/\s*,\s*/)
                                        .map((val) => ({
                                          label: val,
                                          value: val,
                                        }))
                                    : [];

                                const CURRENT_CONDITION =
                                  rowData?.[item.name]?.[
                                    currentCondition.index
                                  ] || [];

                                return (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "start",
                                      gap: "8px",
                                      marginLeft: "20px",
                                      width: "550px",
                                      height: "fit-content",
                                    }}
                                  >
                                    {/* KEY */}
                                    <div style={{ width: "100%" }}>
                                      <Autocomplete
                                        disableClearable
                                        options={levelColKeys || []}
                                        value={KEY || null}
                                        getOptionLabel={(option) =>
                                          option.label || ""
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option.value === value.value
                                        }
                                        renderOption={(
                                          props,
                                          option,
                                          { selected },
                                        ) => {
                                          return (
                                            <li {...props}>{option.label}</li>
                                          );
                                        }}
                                        renderTags={(value, getTagProps) =>
                                          value.map((option, index) => (
                                            <Chip
                                              key={option.value}
                                              label={option.label}
                                              {...getTagProps({ index })}
                                              size="small"
                                            />
                                          ))
                                        }
                                        sx={{
                                          fontSize: "14px", // base font size
                                          "& .MuiInputBase-root": {
                                            padding: "2px 10px 2px 10px",
                                            fontSize: "12px",
                                          },
                                          "& .MuiInputLabel-root": {
                                            fontSize: "14px",
                                          },
                                          "& .MuiAutocomplete-endAdornment": {
                                            top: "calc(100% - 18px)", // center the dropdown icon
                                          },
                                        }}
                                        slotProps={{
                                          popper: {
                                            sx: {
                                              "& .MuiAutocomplete-paper": {
                                                boxShadow:
                                                  "0 2px 8px rgba(0,0,0,0.15)",
                                                borderRadius: "8px",
                                              },
                                              "& .MuiAutocomplete-listbox": {
                                                padding: "4px 0",
                                                fontSize: "12px",
                                              },
                                              "& .MuiAutocomplete-option": {
                                                padding: "4px 6px",
                                                margin: "0px 4px",
                                                borderRadius: "2px",
                                                cursor: "pointer",
                                                transition:
                                                  "background 0.15s ease",
                                              },
                                              "& .MuiAutocomplete-option:hover":
                                                {
                                                  backgroundColor: "#f0f0f0",
                                                },
                                              "& .MuiAutocomplete-option[aria-selected='true']":
                                                {
                                                  backgroundColor:
                                                    "transparent !important",
                                                },
                                              "& .MuiAutocomplete-option.Mui-focused":
                                                {
                                                  backgroundColor:
                                                    "#f5f5f5 !important",
                                                },
                                            },
                                          },
                                        }}
                                        open={false} // 👈 force close always
                                        onOpen={(e) => e.stopPropagation()} // block opening
                                        readOnly
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            inputProps={{
                                              ...params.inputProps,
                                              readOnly: true,
                                            }}
                                            style={{ border: "none" }}
                                          />
                                        )}
                                      />
                                    </div>
                                    <span style={{ width: "10px" }}>:</span>
                                    {/* VALUE */}
                                    <div style={{ width: "100%" }}>
                                      <Autocomplete
                                        multiple
                                        disableCloseOnSelect
                                        options={
                                          getDropdownValues(
                                            item.name,
                                            KEY,
                                            CURRENT_CONDITION,
                                          ) || []
                                        }
                                        value={VALUE}
                                        onChange={(key, val) => {
                                          handleAttributeChange(
                                            currentCondition?.index,
                                            index,
                                            val,
                                            item.name,
                                          );
                                        }}
                                        getOptionLabel={(option) =>
                                          option.label || ""
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option.value === value.value
                                        }
                                        renderOption={(
                                          props,
                                          option,
                                          { selected },
                                        ) => {
                                          let isExisting = VALUE.some((col) => {
                                            return col.value === option.value;
                                          });
                                          return (
                                            <li {...props}>
                                              <Checkbox
                                                checked={isExisting}
                                                sx={{
                                                  transform: "scale(.9)", // scale up (1 = default size)
                                                  padding: "2px", // optional: reduce padding
                                                }}
                                              />
                                              {option.label}
                                            </li>
                                          );
                                        }}
                                        renderTags={(value, getTagProps) =>
                                          value.map((option, index) => (
                                            <Chip
                                              key={option.value}
                                              label={option.label}
                                              {...getTagProps({ index })}
                                              size="small"
                                            />
                                          ))
                                        }
                                        sx={{
                                          fontSize: "14px",

                                          // FIXED HEIGHT + INTERNAL SCROLL
                                          "& .MuiAutocomplete-inputRoot": {
                                            boxSizing: "border-box",
                                            minHeight: "38px",
                                            maxHeight: "auto",
                                            overflowY: "auto",
                                            paddingRight: "28px !important", // space for dropdown icon
                                            display: "flex",
                                            flexWrap: "wrap",
                                            alignItems: "flex-start",
                                          },

                                          "& .MuiAutocomplete-tag": {
                                            margin: "2px",
                                          },

                                          // SCROLLBAR STYLE
                                          "& .MuiAutocomplete-inputRoot::-webkit-scrollbar":
                                            {
                                              width: "6px",
                                            },
                                          "& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb":
                                            {
                                              backgroundColor: "#ccc",
                                              borderRadius: "10px",
                                            },

                                          "& .MuiInputBase-root": {
                                            fontSize: "12px",
                                            padding: "2px 10px",
                                          },
                                        }}
                                        slotProps={{
                                          popper: {
                                            sx: {
                                              "& .MuiAutocomplete-listbox": {
                                                fontSize: "12px", // ⬅️ dropdown font size
                                                padding: "2px 0",
                                              },
                                              "& .MuiAutocomplete-option": {
                                                padding: "4px 6px",
                                              },
                                            },
                                          },
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            style={{ border: "none" }}
                                          />
                                        )}
                                      />
                                    </div>
                                    {/* ACTION BUTTON */}
                                    <div
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "5px",
                                        backgroundColor: "white",
                                        padding: "4px 8px 2px 8px",
                                        borderRadius: "4px",
                                        height: "35px",
                                        marginTop: "2px",
                                        cursor: "pointer",
                                      }}
                                      onClick={() =>
                                        removeAttributeFromObjectTypeCol(
                                          currentCondition?.index,
                                          index,
                                          item.name,
                                        )
                                      }
                                    >
                                      <div>
                                        <i
                                          className="material-icons-outlined "
                                          style={{
                                            color: "red",
                                            marginTop: "5px",
                                            fontWeight: "600",
                                            cursor: "pointer",
                                          }}
                                        >
                                          do_not_disturb_on
                                        </i>
                                      </div>
                                    </div>
                                  </div>
                                );
                              },
                            )}
                          {/* EXISTING ATTRIBUTE DROPDOWNS END */}

                          {/* NEW ATTRIBUTE DROPDOWNS START */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "start",
                              gap: "8px",
                              marginLeft: "20px",
                              width: "582px",
                              height: "fit-content",
                            }}
                          >
                            {/* KEY */}
                            <div style={{ width: "100%" }}>
                              <Autocomplete
                                disableClearable
                                options={levelColKeys || []}
                                value={currentKey || null}
                                onChange={(key, val) => {
                                  updateKeyForAddNewAttributeMethod(val);
                                }}
                                getOptionLabel={(option) => option.label || ""}
                                isOptionEqualToValue={(option, value) =>
                                  option.value === value.value
                                }
                                renderOption={(props, option, { selected }) => {
                                  return <li {...props}>{option.label}</li>;
                                }}
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => (
                                    <Chip
                                      key={option.value}
                                      label={option.label}
                                      {...getTagProps({ index })}
                                      size="small"
                                    />
                                  ))
                                }
                                sx={{
                                  fontSize: "14px", // base font size
                                  "& .MuiInputBase-root": {
                                    padding: "2px 10px 2px 10px",
                                    fontSize: "12px",
                                  },
                                  "& .MuiInputLabel-root": {
                                    fontSize: "14px",
                                  },
                                  "& .MuiAutocomplete-endAdornment": {
                                    top: "calc(100% - 18px)", // center the dropdown icon
                                  },
                                }}
                                slotProps={{
                                  popper: {
                                    sx: {
                                      "& .MuiAutocomplete-paper": {
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                        borderRadius: "8px",
                                      },
                                      "& .MuiAutocomplete-listbox": {
                                        padding: "4px 0",
                                        fontSize: "12px",
                                      },
                                      "& .MuiAutocomplete-option": {
                                        padding: "4px 6px",
                                        margin: "0px 4px",
                                        borderRadius: "2px",
                                        cursor: "pointer",
                                        transition: "background 0.15s ease",
                                      },
                                      "& .MuiAutocomplete-option:hover": {
                                        backgroundColor: "#f0f0f0",
                                      },
                                      "& .MuiAutocomplete-option[aria-selected='true']":
                                        {
                                          backgroundColor:
                                            "transparent !important",
                                        },
                                      "& .MuiAutocomplete-option.Mui-focused": {
                                        backgroundColor: "#f5f5f5 !important",
                                      },
                                    },
                                  },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    style={{ border: "none" }}
                                  />
                                )}
                              />
                            </div>
                            <span style={{ width: "10px" }}>:</span>
                            {/* VALUE */}
                            <div style={{ width: "100%" }}>
                              <Autocomplete
                                multiple
                                disableCloseOnSelect
                                options={getDropdownValues(
                                  item.name,
                                  currentKey,
                                )}
                                value={currentValue || ""}
                                onChange={(key, val) => {
                                  setCurrentValue(val);
                                }}
                                getOptionLabel={(option) => option.label || ""}
                                isOptionEqualToValue={(option, value) =>
                                  option.value === value.value
                                }
                                renderOption={(props, option, { selected }) => {
                                  let isExisting =
                                    currentValue?.some((col) => {
                                      return col.value === option.value;
                                    }) ?? false;
                                  return (
                                    <li {...props}>
                                      <Checkbox
                                        checked={isExisting}
                                        sx={{
                                          transform: "scale(.9)", // scale up (1 = default size)
                                          padding: "2px", // optional: reduce padding
                                        }}
                                      />
                                      {option.label}
                                    </li>
                                  );
                                }}
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => (
                                    <Chip
                                      key={option.value}
                                      label={option.label}
                                      {...getTagProps({ index })}
                                      size="small"
                                    />
                                  ))
                                }
                                sx={{
                                  fontSize: "14px",

                                  // FIXED HEIGHT + INTERNAL SCROLL
                                  "& .MuiAutocomplete-inputRoot": {
                                    boxSizing: "border-box",
                                    minHeight: "38px",
                                    maxHeight: "auto",
                                    overflowY: "auto",
                                    paddingRight: "28px !important", // space for dropdown icon
                                    display: "flex",
                                    flexWrap: "wrap",
                                    alignItems: "flex-start",
                                  },

                                  "& .MuiAutocomplete-tag": {
                                    margin: "2px",
                                  },

                                  // SCROLLBAR STYLE
                                  "& .MuiAutocomplete-inputRoot::-webkit-scrollbar":
                                    {
                                      width: "6px",
                                    },
                                  "& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb":
                                    {
                                      backgroundColor: "#ccc",
                                      borderRadius: "10px",
                                    },

                                  "& .MuiInputBase-root": {
                                    fontSize: "12px",
                                    padding: "2px 10px",
                                  },
                                }}
                                slotProps={{
                                  popper: {
                                    sx: {
                                      "& .MuiAutocomplete-listbox": {
                                        fontSize: "12px", // ⬅️ dropdown font size
                                        padding: "2px 0",
                                      },
                                      "& .MuiAutocomplete-option": {
                                        padding: "4px 6px",
                                      },
                                    },
                                  },
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    style={{ border: "none" }}
                                  />
                                )}
                              />
                            </div>
                            {/* ACTION BUTTON */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                backgroundColor: "#46596a",
                                padding: "4px 8px 2px 8px",
                                borderRadius: "4px",
                                height: "35px",
                                marginTop: "2px",
                                cursor: is_Level_Column_Editable
                                  ? "pointer"
                                  : "not-allowed",
                              }}
                              onClick={() =>
                                addNewAttributeToObjectTypeCol(
                                  currentCondition?.index,
                                  item.name,
                                )
                              }
                            >
                              <div>
                                <i
                                  className="material-icons-outlined "
                                  style={{
                                    color: "white",
                                    marginTop: "5px",
                                    cursor: is_Level_Column_Editable
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                >
                                  add_circle
                                </i>
                              </div>
                              <div
                                style={{
                                  color: "white",
                                  fontSize: "13px",
                                }}
                              >
                                Add
                              </div>
                            </div>
                          </div>
                          {/* NEW ATTRIBUTE DROPDOWNS END*/}
                        </div>
                      )}

                    {/* ADD NEW CONDITION */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "start",
                        gap: "8px",
                        marginLeft: "20px",
                        width: "506px",
                        height: "fit-content",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "start",
                          gap: "8px",
                          width: "100%",
                          height: "fit-content",
                        }}
                      >
                        {/* KEY */}
                        <div style={{ width: "100%" }}>
                          <Autocomplete
                            disableClearable
                            options={levelColKeys || []}
                            value={newConditionKey || null}
                            onChange={(key, val) => {
                              updateKeyforAddConditionMethod(val);
                            }}
                            getOptionLabel={(option) => option.label || ""}
                            isOptionEqualToValue={(option, value) =>
                              option.value === value.value
                            }
                            renderOption={(props, option, { selected }) => {
                              return <li {...props}>{option.label}</li>;
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  key={option.value}
                                  label={option.label}
                                  {...getTagProps({ index })}
                                  size="small"
                                />
                              ))
                            }
                            sx={{
                              fontSize: "14px", // base font size
                              "& .MuiInputBase-root": {
                                padding: "2px 10px 2px 10px",
                                fontSize: "12px",
                              },
                              "& .MuiInputLabel-root": {
                                fontSize: "14px",
                              },
                              "& .MuiAutocomplete-endAdornment": {
                                top: "calc(100% - 18px)", // center the dropdown icon
                              },
                            }}
                            slotProps={{
                              popper: {
                                sx: {
                                  "& .MuiAutocomplete-paper": {
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                    borderRadius: "8px",
                                  },
                                  "& .MuiAutocomplete-listbox": {
                                    padding: "4px 0",
                                    fontSize: "12px",
                                  },
                                  "& .MuiAutocomplete-option": {
                                    padding: "4px 6px",
                                    margin: "0px 4px",
                                    borderRadius: "2px",
                                    cursor: "pointer",
                                    transition: "background 0.15s ease",
                                  },
                                  "& .MuiAutocomplete-option:hover": {
                                    backgroundColor: "#f0f0f0",
                                  },
                                  "& .MuiAutocomplete-option[aria-selected='true']":
                                    {
                                      backgroundColor: "transparent !important",
                                    },
                                  "& .MuiAutocomplete-option.Mui-focused": {
                                    backgroundColor: "#f5f5f5 !important",
                                  },
                                },
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                style={{ border: "none" }}
                              />
                            )}
                          />
                        </div>
                        <span style={{ width: "10px" }}>:</span>
                        {/* VALUE */}
                        <div style={{ width: "100%" }}>
                          <Autocomplete
                            multiple
                            disableCloseOnSelect
                            options={getDropdownValues(
                              item.name,
                              newConditionKey,
                            )}
                            value={newConditionValue || null}
                            onChange={(key, val) => {
                              setNewConditionValue(val);
                            }}
                            getOptionLabel={(option) => option.label || ""}
                            isOptionEqualToValue={(option, value) =>
                              option.value === value.value
                            }
                            renderOption={(props, option, { selected }) => {
                              let isExisting =
                                newConditionValue?.some((col) => {
                                  return col.value === option.value;
                                }) ?? false;
                              return (
                                <li {...props}>
                                  <Checkbox
                                    checked={isExisting}
                                    sx={{
                                      transform: "scale(.9)", // scale up (1 = default size)
                                      padding: "2px", // optional: reduce padding
                                    }}
                                  />
                                  {option.label}
                                </li>
                              );
                            }}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  key={option.value}
                                  label={option.label}
                                  {...getTagProps({ index })}
                                  size="small"
                                />
                              ))
                            }
                            sx={{
                              fontSize: "14px",

                              // FIXED HEIGHT + INTERNAL SCROLL
                              "& .MuiAutocomplete-inputRoot": {
                                boxSizing: "border-box",
                                minHeight: "38px",
                                maxHeight: "auto",
                                overflowY: "auto",
                                paddingRight: "28px !important", // space for dropdown icon
                                display: "flex",
                                flexWrap: "wrap",
                                alignItems: "flex-start",
                              },

                              "& .MuiAutocomplete-tag": {
                                margin: "2px",
                              },

                              // SCROLLBAR STYLE
                              "& .MuiAutocomplete-inputRoot::-webkit-scrollbar":
                                {
                                  width: "6px",
                                },
                              "& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb":
                                {
                                  backgroundColor: "#ccc",
                                  borderRadius: "10px",
                                },

                              "& .MuiInputBase-root": {
                                fontSize: "12px",
                                padding: "2px 10px",
                              },
                            }}
                            slotProps={{
                              popper: {
                                sx: {
                                  "& .MuiAutocomplete-listbox": {
                                    fontSize: "12px", // ⬅️ dropdown font size
                                    padding: "2px 0",
                                  },
                                  "& .MuiAutocomplete-option": {
                                    padding: "4px 6px",
                                  },
                                },
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                style={{ border: "none" }}
                              />
                            )}
                          />
                        </div>
                      </div>

                      {/* ACTION BUTTON */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: "5px",
                          backgroundColor: "#46596a",
                          padding: "4px 8px 2px 8px",
                          borderRadius: "4px",
                          height: "35px",
                          marginTop: "2px",
                          cursor: "pointer",
                        }}
                        onClick={handleAddNewCondition}
                      >
                        <div>
                          <i
                            className="material-icons-outlined "
                            style={{
                              color: "white",
                              marginTop: "5px",
                              cursor: is_Level_Column_Editable
                                ? "pointer"
                                : "not-allowed",
                            }}
                          >
                            add
                          </i>
                        </div>
                        <div
                          style={{
                            color: "white",
                            fontSize: "13px",
                          }}
                        >
                          Add Condition
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    display: "flex",
                    alignItems: "start",
                    gap: "8px",
                    width: "800px",
                    height: "fit-content",
                    marginTop: "16px",
                  }}
                >
                  {/* KEY */}
                  <div style={{ width: "80%" }}>
                    <Autocomplete
                      disableClearable
                      options={levelColKeys || []}
                      value={newConditionKey || null}
                      onChange={(key, val) => {
                        updateKeyforAddConditionMethod(val);
                      }}
                      getOptionLabel={(option) => option.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      renderOption={(props, option, { selected }) => {
                        return <li {...props}>{option.label}</li>;
                      }}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            key={option.value}
                            label={option.label}
                            {...getTagProps({ index })}
                            size="small"
                          />
                        ))
                      }
                      sx={{
                        fontSize: "14px", // base font size
                        "& .MuiInputBase-root": {
                          padding: "2px 10px 2px 10px",
                          fontSize: "12px",
                        },
                        "& .MuiInputLabel-root": {
                          fontSize: "14px",
                        },
                        "& .MuiAutocomplete-endAdornment": {
                          top: "calc(100% - 18px)", // center the dropdown icon
                        },
                      }}
                      slotProps={{
                        popper: {
                          sx: {
                            "& .MuiAutocomplete-paper": {
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                              borderRadius: "8px",
                            },
                            "& .MuiAutocomplete-listbox": {
                              padding: "4px 0",
                              fontSize: "12px",
                            },
                            "& .MuiAutocomplete-option": {
                              padding: "4px 6px",
                              margin: "0px 4px",
                              borderRadius: "2px",
                              cursor: "pointer",
                              transition: "background 0.15s ease",
                            },
                            "& .MuiAutocomplete-option:hover": {
                              backgroundColor: "#f0f0f0",
                            },
                            "& .MuiAutocomplete-option[aria-selected='true']": {
                              backgroundColor: "transparent !important",
                            },
                            "& .MuiAutocomplete-option.Mui-focused": {
                              backgroundColor: "#f5f5f5 !important",
                            },
                          },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField {...params} style={{ border: "none" }} />
                      )}
                    />
                  </div>
                  <span style={{ width: "10px" }}>:</span>
                  {/* VALUE */}
                  <div style={{ width: "100%" }}>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      options={getDropdownValues(item.name, newConditionKey)}
                      value={newConditionValue || null}
                      onChange={(key, val) => {
                        setNewConditionValue(val);
                      }}
                      getOptionLabel={(option) => option.label || ""}
                      isOptionEqualToValue={(option, value) =>
                        option.value === value.value
                      }
                      renderOption={(props, option, { selected }) => {
                        let isExisting =
                          newConditionValue?.some((col) => {
                            return col.value === option.value;
                          }) ?? false;
                        return (
                          <li {...props}>
                            <Checkbox
                              checked={isExisting}
                              sx={{
                                transform: "scale(.9)", // scale up (1 = default size)
                                padding: "2px", // optional: reduce padding
                              }}
                            />
                            {option.label}
                          </li>
                        );
                      }}
                      renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                          <Chip
                            key={option.value}
                            label={option.label}
                            {...getTagProps({ index })}
                            size="small"
                          />
                        ))
                      }
                      sx={{
                        fontSize: "14px",

                        // FIXED HEIGHT + INTERNAL SCROLL
                        "& .MuiAutocomplete-inputRoot": {
                          boxSizing: "border-box",
                          minHeight: "38px",
                          maxHeight: "auto",
                          overflowY: "auto",
                          paddingRight: "28px !important", // space for dropdown icon
                          display: "flex",
                          flexWrap: "wrap",
                          alignItems: "flex-start",
                        },

                        "& .MuiAutocomplete-tag": {
                          margin: "2px",
                        },

                        // SCROLLBAR STYLE
                        "& .MuiAutocomplete-inputRoot::-webkit-scrollbar": {
                          width: "6px",
                        },
                        "& .MuiAutocomplete-inputRoot::-webkit-scrollbar-thumb":
                          {
                            backgroundColor: "#ccc",
                            borderRadius: "10px",
                          },

                        "& .MuiInputBase-root": {
                          fontSize: "12px",
                          padding: "2px 10px",
                        },
                      }}
                      slotProps={{
                        popper: {
                          sx: {
                            "& .MuiAutocomplete-listbox": {
                              fontSize: "12px", // ⬅️ dropdown font size
                              padding: "2px 0",
                            },
                            "& .MuiAutocomplete-option": {
                              padding: "4px 6px",
                            },
                          },
                        },
                      }}
                      renderInput={(params) => (
                        <TextField {...params} style={{ border: "none" }} />
                      )}
                    />
                  </div>
                  {/* ACTION BUTTON */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                      backgroundColor: "#46596a",
                      padding: "4px 8px 2px 8px",
                      borderRadius: "4px",
                      width: "60%",
                      height: "35px",
                      marginTop: "2px",
                      cursor: "pointer",
                    }}
                    onClick={handleAddNewCondition}
                  >
                    <div>
                      <i
                        className="material-icons-outlined "
                        style={{
                          color: "white",
                          marginTop: "5px",
                          cursor: is_Level_Column_Editable
                            ? "pointer"
                            : "not-allowed",
                        }}
                      >
                        add
                      </i>
                    </div>
                    <div
                      style={{
                        color: "white",
                        fontSize: "13px",
                      }}
                    >
                      Add Condition
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        },
      )}
    </div>
  );
};
